module.exports = __webpack_public_path__ + "img/gsgc2902_1.44d961a5.svg";